/* eslint-disable import/no-unresolved */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/control-has-associated-label */
import {
    AccordionItem, AccordionItemBody, AccordionItemHeader, Accordions, Breadcrumb, Button, Input, Radio, RadioGroup, Select, SelectOption,
} from 'appkit-react';
import { Col, Row, Alert } from 'react-bootstrap';

import TenantWarningModal from './TenantWarningModal';
import '../styles/createTenant.scss';

const EditTenant = ({
    history, breadcrumbItems, checkValidation, onSave,
    isChangeTenantNameLoading, isChangeTenantStatusLoading, isEditTenantLoading,
    showErrorAlert, setShowErrorAlert, errorMsg, tenantName, setTenantName,
    tenantNameError, setTenantType, tenantType, tenantTypeError, status, setStatus,
    onboardOrganizationAdmin, setOnboardOrganizationAdmin, allowedDomains,
    setAllowedDomains, successMsg, showSuccessAlert, setShowSuccessAlert,
    showWarningModal, setShowWarningModal, setConfirmDelete,

}) => {
    const isLoading = isChangeTenantNameLoading || isChangeTenantStatusLoading || isEditTenantLoading;
    if (showWarningModal) {
        return (
            <TenantWarningModal
                setConfirmDelete={setConfirmDelete}
                setShowWarningModal={setShowWarningModal}
                showWarningModal={showWarningModal}
            />
        );
    }
    return (
        <div>
            <div className="true-comply-tenant_management_layout">
                <div className="true-comply-tenant_management_column-2">
                    <Breadcrumb items={breadcrumbItems} />
                    <Row>
                        <Col md={5}>
                            <div className="a-h2 title-label">
                                <span className="appkiticon icon-left-chevron-outline left-arrow-icon" onClick={() => history.goBack()} role="presentation" />
                                Edit Tenant
                            </div>
                        </Col>
                        <Col style={{ textAlign: 'right' }}>
                            <Button
                                className="a-btn a-btn-primary a-btn-lg "
                                kind="primary"
                                size="lg"
                                style={{ marginLeft: '2rem' }}
                                onClick={
                                    () => {
                                        checkValidation();
                                        onSave();
                                    }
                                }
                                isLoading={isChangeTenantNameLoading || isChangeTenantStatusLoading || isEditTenantLoading}
                            >
                                Save
                            </Button>
                            <Button className="a-btn a-btn-secondary a-btn-lg " kind="secondary" size="lg" style={{ marginLeft: '1rem' }} onClick={() => history.goBack()}>
                                Cancel
                            </Button>
                        </Col>
                    </Row>
                    {showSuccessAlert && (
                        <Alert variant="success" onClose={() => setShowSuccessAlert(false)} dismissible>{successMsg}</Alert>
                    )}
                    {showErrorAlert && (
                        <Alert variant="danger" onClose={() => setShowErrorAlert(false)} dismissible="true">{errorMsg}</Alert>
                    )}
                    {!isLoading && status === 'INACTIVE' && (
                        <Alert variant="warning">Tenant is Disabled. Please enable the tenant to update the other fields.</Alert>
                    )}
                    <Accordions className="true-comply-create-tenant-accordion" activeItem={['panel-1', 'panel-2']}>
                        <AccordionItem itemId="panel-1" size="lg">
                            <AccordionItemHeader className="background-white header" title="TENANT DETAILS" />
                            <AccordionItemBody className="background-white" size="lg">
                                <hr style={{ marginTop: 0 }} />
                                <Row style={{ paddingBottom: '2rem' }}>
                                    <Col md={6}>
                                        <label className="form-label">
                                            TENANT NAME
                                            <span className="required-field">*</span>
                                        </label>
                                        <Input
                                            type="text"
                                            name="tenantName"
                                            value={tenantName}
                                            onChange={e => { setTenantName(e); }}
                                            hasError={tenantNameError}
                                            errMsg="TENANT NAME is required."
                                            disabled={status === 'false'}
                                        />
                                        <label className="form-label">
                                            TENANT TYPE
                                            <span className="required-field">*</span>
                                        </label>
                                        <Select
                                            placeholder="Select"
                                            onSelect={e => { setTenantType(e); }}
                                            value={tenantType}
                                            name="tenantType"
                                            dropdownRenderMode="portal"
                                            style={{ boxShadow: tenantTypeError ? '0 0 0 0.125rem #c52a1a' : '', borderRadius: tenantTypeError ? '2px' : '' }}
                                            disabled
                                        >
                                            <SelectOption key={1} value="INTERNAL">
                                                Internal
                                            </SelectOption>
                                            <SelectOption key={2} value="EXTERNAL">
                                                External
                                            </SelectOption>
                                        </Select>
                                        {tenantTypeError && <div style={{ color: '#c52a1a', fontSize: '0.75rem', margin: '.625rem 0 0' }}>TENANT TYPE is required.</div>}
                                        <label className="form-label">
                                            TENANT STATUS
                                            <span className="required-field">*</span>
                                        </label>
                                        <RadioGroup
                                            name="status"
                                            value={status}
                                            onChange={(event, value) => {
                                                setStatus(value);
                                            }}
                                            style={{ display: 'flex' }}
                                        >
                                            <Radio
                                                value="ACTIVE"
                                                style={{ marginRight: '1rem' }}
                                            >
                                                Active
                                            </Radio>
                                            <Radio
                                                value="INACTIVE"
                                            >
                                                Inactive
                                            </Radio>
                                        </RadioGroup>
                                    </Col>
                                    <Col md={6}>
                                        <label className="form-label">
                                            ONBOARD ORGANIZATION ADMIN EMAIL
                                            <span className="required-field">*</span>
                                        </label>
                                        <Input
                                            type="text"
                                            name="onboardOrganizationAdmin"
                                            value={onboardOrganizationAdmin}
                                            onChange={e => { setOnboardOrganizationAdmin(e); }}
                                            disabled
                                        />
                                        {/* <label className="form-label">
                                            ALLOWED DOMAINS
                                        </label>
                                        <Input
                                            type="text"
                                            name="allowedDomains"
                                            value={allowedDomains}
                                            onChange={e => { setAllowedDomains(e); }}
                                            disabled
                                        /> */}
                                    </Col>
                                </Row>
                            </AccordionItemBody>
                        </AccordionItem>
                    </Accordions>
                </div>
            </div>
        </div>
    );
};

export default EditTenant;
